import { cn } from "@suraasa/placebo-ui"

import { useSuraasaPlusContext } from "../../context"
import SuraasaPlusLogo, { LogoVariant } from "../SuraasaPlusLogo"
import styles from "./GradientButton.module.css"

const SuraasaPlusGradientButton = ({
  className,
  logoHeight,
  logoWidth,
  variant = LogoVariant.full,
}: {
  className?: string
  variant?: LogoVariant
  logoHeight: number
  logoWidth: number
}) => {
  const { isFreeTrialAvailable, initiateSuraasaPlusPurchaseFlow } =
    useSuraasaPlusContext()

  return (
    <button
      onClick={() => {
        initiateSuraasaPlusPurchaseFlow()
      }}
      className={cn(styles.gradientButton, className)}
    >
      <span className="flex items-baseline gap-0.5 whitespace-nowrap text-strongSmallBody font-bold tracking-tight">
        {isFreeTrialAvailable ? "Try " : "Get "}
        <span
          style={{
            height: logoHeight,
            width: logoWidth,
          }}
          className="inline-flex items-center"
        >
          <SuraasaPlusLogo
            height={logoHeight}
            width={logoWidth}
            variant={variant}
          />
        </span>
      </span>
    </button>
  )
}

export default SuraasaPlusGradientButton
